import React, { lazy, Suspense } from 'react';
import { cx } from '@linaria/core';
import iconsList from '../../assets/icons/iconsList';
import { useTheme } from '../ThemeProvider/ThemeProvider';
import { Root } from './styles';
const Icon = ({ name, type = 'regular', asMulticolor = false }) => {
    const { id } = useTheme();
    const baseIconName = `${name.charAt(0).toUpperCase() + name.slice(1)}`;
    const iconSet = iconsList.find((item) => item.value === id)?.iconSet || 'default';
    const multicolorIconName = `${baseIconName}Multicolor`;
    const fallbackIconName = `${baseIconName}${type.charAt(0).toUpperCase() + type.slice(1)}`;
    const loadIconComponent = async (iconName) => {
        try {
            return await import(
            /* webpackChunkName: "icon-[request]" */
            `../../assets/icons/${iconSet}/${iconName}`);
        }
        catch (error) {
            return { default: () => null };
        }
    };
    const IconComponent = lazy(async () => {
        if (asMulticolor) {
            const multicolorIcon = await loadIconComponent(multicolorIconName);
            if (multicolorIcon.default.length > 0) {
                return multicolorIcon;
            }
        }
        const icon = await loadIconComponent(fallbackIconName);
        if (icon.default.length === 0) {
            console.info('Icon name not found: ', name, type);
        }
        return icon;
    });
    return (React.createElement(Suspense, { fallback: React.createElement("svg", { "data-name": asMulticolor ? multicolorIconName : fallbackIconName }) },
        React.createElement(IconComponent, { className: cx(Root.base) })));
};
export default React.memo(Icon);
